import '../plugins/slickPlugin';

// slick init
export default function initSlickCarousel() {
  jQuery('.slider-without-arrow').slick({
    slidesToScroll: 1,
    prevArrow: '<button class="slick-prev icon-left"></button>',
    nextArrow: '<button class="slick-next icon-next"></button>',
    infinite: true,
    autoplay: true,
    dots: true,
    centerPadding: '60px',
    dotsClass: 'slick-dots',
    slidesToShow: 1,
  });

  jQuery('.slider-quote').slick({
    slidesToScroll: 1,
    infinite: true,
    dots: true,
    dotsClass: 'slick-dots',
    prevArrow: false,
    nextArrow: false,
    centerPadding: '60px',
    arrows: false,
    appendDots: $('.hold'),
    slidesToShow: 1,
  });

  jQuery('.slick-slider-blog').each(function () {
    let $slider = $(this);
    $slider.slick({
      infinite: false,
      slidesToScroll: 1,
      slidesToShow: 1,
      mobileFirst: true,
      arrows: false,
      prevArrow: '<button class="slick-prev icon-left"></button>',
      nextArrow: '<button class="slick-next icon-next"></button>',
      dots: true,
      dotsClass: 'slick-dots',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: 0 !== $slider.data('slick-arrows'),
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        }
      ]
    });
  });
}
